<div class="mutual-funds-container info-card mb-4">
  <div class="card-header">
    <span class="card-title mb-0"> Current Holdings </span>
  </div>
  @if (
    objMissingValue(chartDetails.DisplayFX, 'ShowAccountPositionsTabFX') ||
    objMissingValue(chartDetails.DisplayFX, 'ShowClientPositionsTabFX') ||
    objMissingValue(chartDetails.DisplayFX, 'ShowHouseholdPositionsTabFX') ||
    chartDetails.DisplayFX?.['ShowAccountPositionsTabFX'] ||
    chartDetails.DisplayFX?.['ShowClientPositionsTabFX'] ||
    chartDetails.DisplayFX?.['ShowHouseholdPositionsTabFX']
  ) {
    <div class="actions-card">
      <div class="custom-tabs">
        <mat-tab-group
          [selectedIndex]="selectedHoldingTab"
          (selectedTabChange)="changeHoldingTab($event)"
        >
          @if (
            objMissingValue(
              chartDetails.DisplayFX,
              'ShowAccountPositionsTabFX'
            ) || chartDetails.DisplayFX?.['ShowAccountPositionsTabFX']
          ) {
            <mat-tab label="Account">
              <app-expanding-table
                [dataset]="chartDetails.AccountPositionsTabFX"
                [evalKey]="tradePositionKey"
              />
            </mat-tab>
          }

          @if (
            objMissingValue(
              chartDetails.DisplayFX,
              'ShowClientPositionsTabFX'
            ) || chartDetails.DisplayFX?.['ShowClientPositionsTabFX']
          ) {
            <mat-tab label="Client">
              <app-expanding-table
                [dataset]="chartDetails.ClientPositionsTabFX"
                [evalKey]="tradePositionKey"
              />
            </mat-tab>
          }

          @if (
            objMissingValue(
              chartDetails.DisplayFX,
              'ShowHouseholdPositionsTabFX'
            ) || chartDetails.DisplayFX?.['ShowHouseholdPositionsTabFX']
          ) {
            <mat-tab label="Household">
              <app-expanding-table
                [dataset]="chartDetails.HouseholdPositionsTabFX"
                [evalKey]="tradePositionKey"
              />
            </mat-tab>
          }
        </mat-tab-group>
      </div>

      @if (
        chartOptions &&
        (chartDetails.Chart_Acct_PT ||
          chartDetails.Chart_Acct_Reg ||
          chartDetails.Chart_Acct_Family ||
          chartDetails.Chart_Client_PT ||
          chartDetails.Chart_Client_Reg ||
          chartDetails.Chart_Client_Family ||
          chartDetails.Chart_House_PT ||
          chartDetails.Chart_House_Reg ||
          chartDetails.Chart_House_Family)
      ) {
        <div class="px-4 pt-3 holdings-visual-container">
          <div>
            <mat-form-field class="me-2">
              <mat-label>Filter Type</mat-label>
              <mat-select
                [value]="chartSelection"
                (selectionChange)="changeChartSelection($event)"
              >
                <mat-option [value]="'PT'"> Product Type </mat-option>
                <mat-option [value]="'Reg'"> Account Registration </mat-option>
                <mat-option [value]="'Family'"> Fund Family </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="chart-container clearfix mb-2">
            @if (showChart() === 'hide') {
              <div class="no-data">No chart available</div>
            }
            <div class="chart px-4 col-6 {{ showChart() }}">
              <highcharts-chart
                [Highcharts]="Highcharts"
                [options]="chartOptions"
                [(update)]="updateFlag"
              />
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="actions-card">
      <div class="no-data"> No holdings data to display </div>
    </div>
  }
</div>
